var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.sessionTimeout)?_c('session-expire-modal',{attrs:{"message":_vm.s__(
      'SAML|Please, reload the page and sign in again, if necessary. To avoid data loss, if you have unsaved edits, dismiss the modal and copy the unsaved text before refreshing the page.',
    ),"session-timeout":_vm.sessionTimeout,"title":_vm.s__('SAML|Your SAML session has expired')}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }